import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import styles from './wizard-steps.styl'

export default class WizardSteps extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired
  }
  static defaultProps = {}

  render() {
    const { children } = this.props
    const content = [].concat(children)
    const steps = content.map(item => item.props)
    const stepContent = steps
      .filter(item => item.state === item.activeState)
      .map(item => get(item, 'children'))[0]
    const noContentClass = stepContent ? '' : styles.noContent

    return (
      <div className={styles.wizardSteps}>
        <ul className={`${styles.list} ${noContentClass}`}>
          {children}
        </ul>
        <div className={styles.content}>
          {stepContent}
        </div>
      </div>
    )
  }
}
